import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { Amplify, ResourcesConfig } from 'aws-amplify';
import config from './config.js';
import { LoggerService } from './app/core/logging/logger.service';

const logger = new LoggerService();

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  logger.error('Bootstrap error', err);
});

const domain = `${config.application_name}-${config.environment_name}.auth.${config.AWS_REGION}.amazoncognito.com`;

const awsConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolClientId: config.AWS_COGNITO_CLIENT_ID,
      userPoolId: config.AWS_COGNITO_USER_POOL_ID,
      identityPoolId: config.AWS_COGNITO_IDENTITY_POOL_ID, // REQUIRED - Amazon Cognito Identity Pool ID
      loginWith: {
        oauth: {
          domain,
          scopes: [
            'openid',
            'email',
            'profile',
            `API-Integration/${config.application_name}-${config.environment_name}-api-integration`,
          ],
          redirectSignIn: [
            `${config.APP_DOMAIN_ENDPOINT}/auth/callback`,
            'http://localhost:4200/auth/callback',
          ],
          redirectSignOut: [
            `${config.APP_DOMAIN_ENDPOINT}/auth/login`,
            'http://localhost:4200/auth/login',
          ],
          responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
        },
      },
    },
  },
};
Amplify.configure(awsConfig);
